import { Link } from "react-router-dom";

function App({ id, title = ""}) {
  // get the teams in the backend;
  return (
    <Link
      className="flex faqbox"
      to={`/faq/${id}`}
    >
      <span >
        {title}
      </span>
    </Link>
  );
}

export default App;
